module.exports = __webpack_public_path__ + "img/img_hope02.a9d821d1.webp";